module.exports = {
  /**
   * Earth gravity in m/s^2
   */
  g: 9.80665,
};
